import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=5de51861&scoped=true&"
import script from "./CertificateForm.vue?vue&type=script&lang=js&"
export * from "./CertificateForm.vue?vue&type=script&lang=js&"
import style0 from "./CertificateForm.vue?vue&type=style&index=0&id=5de51861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de51861",
  null
  
)

/* custom blocks */
import block0 from "./CertificateForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports